﻿import $ from "jquery";
import { ChangeAgendaDto, PlayerItemDto, MeetItemDto } from "./changeAgendaDto";
import { EditableItemList, MovingDirection } from "./editableItemList";
import { TextEditor } from "./textEditor";

//new
export class EditableAgendaLayoutList extends EditableItemList<ChangeAgendaDto> {
    private readonly emptyGuidString = "00000000-0000-0000-0000-000000000000";


    init(divElementId: string) {
        this.itemList = $(`#${divElementId}`).data("initial");

        super.init(divElementId, "addAgendaItemButton");
    }



    protected drawItem(item: ChangeAgendaDto, itemId: number) {
        // == is placed here on purpose for comparison of string.empty
        const teaserPreviewUrl = item.TeaserImageId === this.emptyGuidString ? "" : `/fileasset/${item.TeaserImageId}`;
        const meetLogoUrl = item.MeetLogoId === this.emptyGuidString ? "" : `/fileasset/${item.MeetLogoId}`;
        const agendaImageUrl = item.AgendaImageId === this.emptyGuidString ? "" : `/fileasset/${item.AgendaImageId}`;
        const PlayerPreviewImageUrl = item.PlayerPreviewImageId == this.emptyGuidString ? "" : `/fileasset/${item.PlayerPreviewImageId}`;
        const MeetJoinImagePreviewUrl = item.MeetJoinImageId == this.emptyGuidString ? "" : `/fileasset/${item.MeetJoinImageId}`;

        fetch('/partialview/agenda')
            .then(response => response.text())
            .then(htmlElement => {

                var re = /itemId/gi;
                var itemElement = htmlElement.replace(re, ("" + itemId));
                var itemElement = itemElement.replace("{{title}}", item.Title == null ? "" : item.Title);
                var itemElement = itemElement.replace("{{startAt}}", this.getDateTimeString(item.StartAt));
                var itemElement = itemElement.replace("{{finishAt}}", this.getDateTimeString(item.FinishAt));
                var itemElement = itemElement.replace("{{Description}}", item.Description == null ? "" : item.Description);
                var itemElement = itemElement.replace("{{ShortDescription}}", item.ShortDescription == null ? "" : item.ShortDescription);
                var itemElement = itemElement.replace("{{FontColor}}", item.FontColor);
                var itemElement = itemElement.replace("{{DescriptionBackground}}", item.Background);
                var itemElement = itemElement.replace("{{MeetName}}", item.MeetName == null ? "" : item.MeetName);
                var itemElement = itemElement.replace("{{Meet}}", item.MeetName == null ? "" : item.MeetName);
                var itemElement = itemElement.replace("{{MeetWelcomeMessage}}", item.MeetWelcomeMessage == null ? "" : item.MeetWelcomeMessage);
                var itemElement = itemElement.replace("{{MeetWelcomeMessageModerator}}", item.MeetWelcomeMessageModerator == null ? "" : item.MeetWelcomeMessageModerator);
                var itemElement = itemElement.replace("{{MeetBackgroundColor}}", item.MeetBackgroundColor == null ? "" : item.MeetBackgroundColor);
                var itemElement = itemElement.replace("{{MeetLogoutUrl}}", item.MeetLogoutUrl == null ? "" : item.MeetLogoutUrl);
                var itemElement = itemElement.replace("{{PlayerHeader}}", item.PlayerHeader == null ? "" : item.PlayerHeader);
                var itemElement = itemElement.replace("{{PlayerContent}}", item.PlayerContent == null ? "" : item.PlayerContent); //dafuq?
                var itemElement = itemElement.replace("{{TeaserImagePreview}}", teaserPreviewUrl);
                var itemElement = itemElement.replace("{{AgendaImagePreview}}", agendaImageUrl);
                var itemElement = itemElement.replace("{{MeetLogoPreview}}", meetLogoUrl);
                var itemElement = itemElement.replace("{{PlayerPreviewImagePreview}}", PlayerPreviewImageUrl);
                var itemElement = itemElement.replace("{{sedcardMeetJoinImage}}", MeetJoinImagePreviewUrl);

                if (item.PlayerItems == null) {
                    console.log("initin playeritems");
                    item.PlayerItems = [];
                }

                if (item.PlayerItems.length == 0) {
                    console.log("list has no elements, creating new list");

                    item.PlayerItems = [];

                    for (let i = 0; i < 4; i++) {
                        const dto: PlayerItemDto = {
                            ItemImageId: this.emptyGuidString,
                            Index: "" + i,
                            Title: "",
                            Description: "",
                            PlayerIframe: "",
                            ItemImageChanged: null
                        };
                        item.PlayerItems[i] = dto;
                    }
                }
                else {
                    console.log("list is not null");
                }

                if (item.MeetItems == null) {
                    console.log("initin meetitems");
                    item.MeetItems = [];
                }

                if (item.MeetItems.length == 0) {
                    console.log("meetlist has no elements, creating new list");

                    item.MeetItems = [];

                    for (let i = 0; i < 4; i++) {
                        const mdto: MeetItemDto = {
                            MeetLogoId: this.emptyGuidString,
                            MeetJoinImage: this.emptyGuidString,
                            MeetPresentationId: this.emptyGuidString,
                            Index: "" + i,
                            MeetName: "",
                            MeetDescription: "",
                            MeetWelcomeMessage: "Wilkommen zu Streamdiver Meet!<br>Hier finden Sie die Bedienungsanleitung: https://sdv.to/mud <br>Here you can find the user manual: https://sdv.to/mue",
                            MeetWelcomeMessageModerator: "Hier finden Sie die Bedienungsanleitung für Moderatoren: https://sdv.to/mmd",
                            MeetLogoChanged: null,
                            MeetJoinImageChanged: null,
                            MeetPresentationChanged: null,
                            StartAt: new Date(),
                            FinishAt: new Date(),
                            MeetBackgroundColor: "#06172A",
                            MeetLogoutUrl: "https://streamdiver.com",
                        };
                        item.MeetItems[i] = mdto;
                    }
                }
                else {
                    console.log("meetlist is not null");
                }

                console.log(item.PlayerItems);
                for (let n = 0; n < item.PlayerItems.length; n++) {
                    const PlayerImageUrl = item.PlayerItems[n].ItemImageId == this.emptyGuidString ? "" : `/fileasset/${item.PlayerItems[n].ItemImageId}`;
                    
                    console.log(PlayerImageUrl);

                    var itemElement = itemElement.replace(("{{PlayerHeader" + item.PlayerItems[n].Index + "}}"), item.PlayerItems[n].Title == null ? "" : item.PlayerItems[n].Title);
                    var itemElement = itemElement.replace(("{{PlayerContent" + item.PlayerItems[n].Index + "}}"), item.PlayerItems[n].PlayerIframe == null ? "" : item.PlayerItems[n].PlayerIframe);
                    var itemElement = itemElement.replace(("{{Description" + item.PlayerItems[n].Index + "}}"), item.PlayerItems[n].Description == null ? "" : item.PlayerItems[n].Description);
                    var itemElement = itemElement.replace(("{{PlayerPreviewImagePreview" + item.PlayerItems[n].Index + "}}"), PlayerImageUrl);

                }

                console.log(item.MeetItems);
                for (let n = 0; n < item.MeetItems.length; n++) {
                    var itemElement = itemElement.replace(("{{MeetName" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetName == null ? "" : item.MeetItems[n].MeetName);
                    var itemElement = itemElement.replace(("{{MeetDescription" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetDescription == null ? "" : item.MeetItems[n].MeetDescription);
                    var itemElement = itemElement.replace(("{{MeetWelcomeMessage" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetWelcomeMessage == null ? "" : item.MeetItems[n].MeetWelcomeMessage);
                    var itemElement = itemElement.replace(("{{MeetWelcomeMessageModerator" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetWelcomeMessageModerator == null ? "" : item.MeetItems[n].MeetWelcomeMessageModerator);
                    var itemElement = itemElement.replace(("{{StartAt" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].StartAt == null ? "" : this.getDateTimeString(item.MeetItems[n].StartAt));
                    var itemElement = itemElement.replace(("{{FinishAt" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].FinishAt == null ? "" : this.getDateTimeString(item.MeetItems[n].FinishAt));
                    var itemElement = itemElement.replace(("{{MeetBackgroundColor" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetBackgroundColor == null ? "" : item.MeetItems[n].MeetBackgroundColor);
                    var itemElement = itemElement.replace(("{{MeetLogoutUrl" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetLogoutUrl == null ? "" : item.MeetItems[n].MeetLogoutUrl);
                    var itemElement = itemElement.replace(("{{MeetLogoId" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetLogoId == null ? "" : item.MeetItems[n].MeetLogoId);
                    var itemElement = itemElement.replace(("{{MeetJoinImage" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetJoinImage == null ? "" : item.MeetItems[n].MeetJoinImage);
                    var itemElement = itemElement.replace(("{{MeetPresentationId" + item.MeetItems[n].Index + "}}"), item.MeetItems[n].MeetPresentationId == null ? "" : item.MeetItems[n].MeetPresentationId);
                }

                $(`#${this.divElementId}`).append(itemElement);

                for (let j = 0; j < item.PlayerItems.length; j++) {

                    $(`#LayoutPlayerHeader-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].PlayerItems[j].Title = String($(`#LayoutPlayerHeader-${itemId}-${j}`).val());
                    });

                    $(`#layoutDescriptionEditorInput-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].PlayerItems[j].PlayerIframe = String($(`#LayoutPlayerContent-${itemId}-${j}`).val());
                    });

                    $(`#layoutDescriptionEditorInput-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].PlayerItems[j].Description = String($(`#layoutDescriptionEditorInput-${itemId}-${j}`).val());
                    });

                    $(`#layoutPlayerPreviewImageInput-${itemId}-${j}`).change(() => {
                        console.log("IMAGE CHANGED");
                        this.readUrl($(`#layoutPlayerPreviewImageInput-${itemId}-${j}`)[0], `layoutPlayerPreviewImagePreview-${itemId}-${j}`, `layoutPlayerPreviewImageLabel-${itemId}-${j}`);
                    });

                    const playerdescriptionTextEditor = new TextEditor();
                    playerdescriptionTextEditor.init(`layoutDescriptionEditor-${itemId}-${j}`, `layoutDescriptionEditorInput-${itemId}-${j}`);
                }

                for (let j = 0; j < item.MeetItems.length; j++) {

                    $(`#layoutMeetName-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetName = String($(`#layoutMeetName-${itemId}-${j}`).val());
                    });

                    $(`#layoutMeetDescription-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetDescription = String($(`#layoutMeetDescription-${itemId}-${j}`).val());
                    });

                    $(`#layoutMeetWelcomeMessage-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetWelcomeMessage = String($(`#layoutMeetWelcomeMessage-${itemId}-${j}`).val());
                    });

                    $(`#MeetWelcomeMessageModerator-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetWelcomeMessageModerator = String($(`#MeetWelcomeMessageModerator-${itemId}-${j}`).val());
                    });

                    $(`#layoutMeetBackgroundColor-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetBackgroundColor = String($(`#layoutMeetBackgroundColor-${itemId}-${j}`).val());
                    });

                    $(`#layoutMeetLogoutUrl-${itemId}-${j}`).change(() => {
                        this.itemList[itemId].MeetItems[j].MeetLogoutUrl = String($(`#layoutMeetLogoutUrl-${itemId}-${j}`).val());
                    });


                    $(`#layoutMeetJoinImageInput-${itemId}-${j}`).change(() => {
                        console.log("IMAGE CHANGED");
                        this.readUrl($(`#layoutMeetJoinImageInput-${itemId}-${j}`)[0], `layoutMeetJoinImagePreview-${itemId}-${j}`, `layoutMeetJoinImageLabel-${itemId}-${j}`);
                    });

                    $(`#layoutMeetLogoInput-${itemId}-${j}`).change(() => {
                        console.log("IMAGE CHANGED");
                        this.readUrl($(`#layoutMeetLogoInput-${itemId}-${j}`)[0], `layoutMeetLogoPreview-${itemId}-${j}`, `layoutMeetLogoLabel-${itemId}-${j}`);
                    });

                    const playerdescriptionTextEditor = new TextEditor();
                    playerdescriptionTextEditor.init(`layoutDescriptionEditor-${itemId}-${j}`, `layoutDescriptionEditorInput-${itemId}-${j}`);
                }


                $(`#Layouttitle-${itemId}`).change(() => {
                    this.itemList[itemId].Title = String($(`#Layouttitle-${itemId}`).val());
                });

                $(`#LayoutStartAt-${itemId}`).change(() => {
                    this.itemList[itemId].StartAt = new Date(String($(`#LayoutStartAt-${itemId}`).val()));
                });

                $(`#LayoutFinishAt-${itemId}`).change(() => {
                    this.itemList[itemId].FinishAt = new Date(String($(`#LayoutStartAt-${itemId}`).val()));
                });

                $(`#layoutDescriptionEditorInput-${itemId}`).change(() => {
                    this.itemList[itemId].Description = String($(`#layoutDescriptionEditorInput-${itemId}`).val());
                });

                $(`#layoutShortDescriptionEditorInput-${itemId}`).change(() => {
                    this.itemList[itemId].ShortDescription = String($(`#layoutShortDescriptionEditorInput-${itemId}`).val());
                });

                $(`#LayoutDescriptionBackgroundColor-${itemId}`).change(() => {
                    this.itemList[itemId].Background = String($(`#LayoutDescriptionBackgroundColor-${itemId}`).val());
                });

                $(`#LayoutFontColor-${itemId}`).change(() => {
                    this.itemList[itemId].FontColor = String($(`#LayoutFontColor-${itemId}`).val());
                });

                $(`#layoutMeetName-${itemId}`).change(() => {
                    this.itemList[itemId].MeetName = String($(`#layoutMeetName-${itemId}`).val());
                });

                $(`#layoutMeetWelcomeMessage-${itemId}`).change(() => {
                    this.itemList[itemId].MeetWelcomeMessage = String($(`#layoutMeetWelcomeMessage-${itemId}`).val());
                });

                $(`#layoutMeetWelcomeMessageModerator-${itemId}`).change(() => {
                    this.itemList[itemId].MeetWelcomeMessageModerator = String($(`#layoutMeetWelcomeMessageModerator-${itemId}`).val());
                });

                $(`#MeetBackgroundColor-${itemId}`).change(() => {
                    this.itemList[itemId].MeetBackgroundColor = String($(`#MeetBackgroundColor-${itemId}`).val());
                });

                $(`#layoutMeetLogoutUrl-${itemId}`).change(() => {
                    this.itemList[itemId].MeetLogoutUrl = String($(`#layoutMeetLogoutUrl-${itemId}`).val());
                });

                $(`#LayoutPlayerHeader-${itemId}`).change(() => {
                    this.itemList[itemId].PlayerHeader = String($(`#LayoutPlayerHeader-${itemId}`).val());
                });

                $(`#LayoutPlayerContent-${itemId}`).change(() => {
                    this.itemList[itemId].PlayerContent = String($(`#LayoutPlayerContent-${itemId}`).val());
                });




                $(`#layoutTeaserImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#layoutTeaserImageInput-${itemId}`)[0], `layoutTeaserImagePreview-${itemId}`, `layoutTeaserImageLabel-${itemId}`);
                });

                $(`#layoutAgendaImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#layoutAgendaImageInput-${itemId}`)[0], `layoutAgendaImagePreview-${itemId}`, `layoutAgendaImageLabel-${itemId}`);
                });

                $(`#layoutMeetLogoInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#layoutMeetLogoInput-${itemId}`)[0], `layoutMeetLogoPreview-${itemId}`, `layoutMeetLogoLabel-${itemId}`);
                });

                $(`#layoutPlayerPreviewImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#layoutPlayerPreviewImageInput-${itemId}`)[0], `layoutPlayerPreviewImagePreview-${itemId}`, `layoutPlayerPreviewImageLabel-${itemId}`);
                });

                $(`#layoutMeetJoinImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#layoutMeetJoinImageInput-${itemId}`)[0], `layoutMeetJoinImagePreview-${itemId}`, `layoutMeetJoinImageLabel-${itemId}`);
                });


                $(`#agendaTopicFieldMoveUp-${itemId}`).click(() => {
                    this.moveItem(MovingDirection.Up, itemId);
                    this.redrawItems();
                });

                $(`#agendaTopicFieldMoveDown-${itemId}`).click(() => {
                    this.moveItem(MovingDirection.Down, itemId);
                    this.redrawItems();
                });

                $(`#agendaTopicFieldRemove-${itemId}`).click(() => {
                    this.itemList.splice(itemId, 1);
                    this.redrawItems();
                });

                const descriptionTextEditor = new TextEditor();
                descriptionTextEditor.init(`layoutDescriptionEditor-${itemId}`, `layoutDescriptionEditorInput-${itemId}`);
            });
    }

    protected addNewItem() {
        const defaultAgendaDto: ChangeAgendaDto = {
            Background: "#D6D6D6",
            Description: "",
            ShortDescription: "",
            AgendaImageId: this.emptyGuidString,
            AgendaImageChanged: null,
            FinishAt: new Date(Date.now()),
            FontColor: "#000000",
            StartAt: new Date(Date.now()),
            TeaserImageId: this.emptyGuidString,
            TeaserImageChanged: null,
            Title: "Titel",
            MeetLogoId: this.emptyGuidString,
            MeetLogoChanged: null,
            MeetJoinImageId: this.emptyGuidString,
            MeetJoinImageChanged: null,
            MeetPresentationId: this.emptyGuidString,
            MeetPresentationChanged: null,
            MeetName: "Meetingname",
            MeetBackgroundColor: "#06172A",
            MeetLogoutUrl: "https://streamdiver.com",
            MeetWelcomeMessage: "Wilkommen zu Streamdiver Meet!<br>Hier finden Sie die Bedienungsanleitung: https://sdv.to/mud <br>Here you can find the user manual: https://sdv.to/mue",
            MeetWelcomeMessageModerator: "Wilkommen Moderator",
            PlayerContent: "",
            PlayerHeader: "",
            PlayerPreviewImageId: this.emptyGuidString,
            PlayerPreviewImageChanged: null,
            PlayerItems: [],
            MeetItems: []
        };

        for (let i = 0; i < 4; i++) {
            const dto: PlayerItemDto = {
                ItemImageId: this.emptyGuidString,
                Index: "" + i,
                Title: "",
                Description: "",
                PlayerIframe: "",
                ItemImageChanged: null
            };
            defaultAgendaDto.PlayerItems[i] = dto;
        }

        for (let i = 0; i < 4; i++) {
            const mdto: MeetItemDto = {
                MeetLogoId: this.emptyGuidString,
                MeetJoinImage: this.emptyGuidString,
                MeetPresentationId: this.emptyGuidString,
                Index: "" + i,
                MeetName: "",
                MeetWelcomeMessage: "Wilkommen zu Streamdiver Meet!<br>Hier finden Sie die Bedienungsanleitung: https://sdv.to/mud <br>Here you can find the user manual: https://sdv.to/mue",
                MeetWelcomeMessageModerator: "Hier finden Sie die Bedienungsanleitung für Moderatoren: https://sdv.to/mmd",
                MeetLogoChanged: null,
                MeetJoinImageChanged: null,
                MeetPresentationChanged: null,
                StartAt: new Date(),
                FinishAt: new Date(),
                MeetBackgroundColor: "#06172A",
                MeetLogoutUrl: "https://streamdiver.com",
            };
            defaultAgendaDto.MeetItems[i] = mdto;
        }
        this.itemList.push(defaultAgendaDto);
    }

    // See https://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
    protected readUrl(input, previewId, labelId) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (e !== null && e.target !== null) {
                    $("#" + previewId).prop("src", e.target.result);
                }
            }

            // Set input label
            reader.readAsDataURL(input.files[0]); // convert to base64 string
            $("#" + labelId).val(input.files[0].name);
        }
    }

    // Returns a date as string in the format yyyy-MM-ddThh:mm
    protected getDateTimeString(date: Date) {
        // For some strange reason, the parameter date can not be used directly ...
        // Therefore, another variable must be initialized
        const sameDate = new Date(date);
        return (`${sameDate.getFullYear().toString()}-${(`0${sameDate.getMonth() + 1}`).slice(-2)}-${(`0${sameDate.getDate()}`).slice(-2)}T${(`0${sameDate.getHours()}`).slice(-2)}:${(`0${sameDate.getMinutes()}`).slice(-2)}`)
    }
}